// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-RRIQBU',
  builtAt: '2026-11-04T07:22:25.222Z'
};
